export default {
  page: {
    home: "Startseite",
    registration_list: "Registrierungsliste",
    search: "Suche",
    skills: "Die Kompetenzen",
    skills_stats: "Statistiken",
    dashboard: "Dashboard",
    questionnaires: "Die Fragebögen",
    weblinks: "Ihre nützlichen Links",
    gradebook: "Ihre Zeugnisse",
    attestations: "Ihre Anwesenheitsbescheinigungen",
    message: "Nachrichten",
    document: "Ihre geteilten Dokumente",
    document_add: "Dokument hinzufügen",
    document_add_note: "Notiz hinzufügen",
    lessons: "Ihre Kurse",
    timetable: "Ihr Stundenplan",
    absence: "Anwesenheitsverwaltung",
    profile: "Profil",
    questionnaire: "Fragebogen",
    training_list: "Liste der Ausbildungen",
    registration_dashboard: "Anmeldungs-Dashboard",
    training_dashboard: "Ausbildungs-Dashboard",
    pre_registration: "Voranmeldeformular",
    pre_registration_edit: "Konfiguration des Voranmeldeformulars",
    step_edit: "Konfiguration der Schritte",
    contract: "Vertrag",
    training_course_list: "Liste der Gruppen",
    driver_licence_config: "Verwaltung der Führerschein-B-Beihilfen",
    driver_licence_list: "Liste der Anträge auf Führerschein-B-Beihilfe",
    driver_licence: "Führerschein-B-Beihilfe",
    login: "Anmeldung",
    notepad: "Notizbuch",
    new_message: "Neue Nachricht",
    new_password: "Neues Passwort",
    reset_password: "Passwort zurücksetzen",
    error: "Fehler",
    switch: "Anmeldung",
    maintenance: "Wartung",
    platformNotFount: "Plattform nicht konfiguriert",
    download: {
      title: "Dateidownload",
      processing: "Download läuft...",
      success: "Datei erfolgreich heruntergeladen!",
    },
  },
};
